    <template>
        <label class="checkbox-wrapper">
        <input type="checkbox" :checked="checked" id="agree" :disabled="disabled" @change="$emit('change', $event.target.checked)">
        <span class="custom-checkbox"></span>
        </label>

</template>
<script>
export default ({
  name: 'checkbox',
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }

})
</script>
<style lang="scss" scoped>
 .checkbox-wrapper {
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
      user-select: none;
      width: fit-content;
    }

    .checkbox-wrapper input[type="checkbox"] {
      display: none;
    }

    .custom-checkbox {
      width: 20px;
      height: 20px;
      border: 2px solid #555;
      border-radius: 4px;
      background-color: white;
      position: relative;
      transition: all 0.2s ease;
    }

    .checkbox-wrapper input[type="checkbox"]:checked + .custom-checkbox {
      background-color: #4caf50;
      border-color: #4caf50;
    }

    .custom-checkbox::after {
      content: '';
      position: absolute;
      left: 4px;
      top: 0px;
      width: 6px;
      height: 12px;
      border: solid white;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    .checkbox-wrapper input[type="checkbox"]:checked + .custom-checkbox::after {
      opacity: 1;
    }

</style>
